import { http } from "@/utils/http";

export interface InvitationCode {
  id: number;
  code: string;
  createdAt: string;
}

export interface InvitationUsage {
  id: number;
  invitationCodeId: number;
  inviteeId: number;
  inviteeUsername: string;
  usedAt: string;
  inviteeHasReviewed: boolean;
  inviteeReviewedAt: string | null;
  premiumGranted: boolean;
}

export const invitationApi = {
  /**
   * Get or create my permanent invitation code
   * 获取或自动生成我的永久邀请码（每个用户只有一个）
   */
  getOrCreateMyCode: async (): Promise<InvitationCode> => {
    const response = await http.get<InvitationCode>("/api/v1/invitations/my-code");
    return response.data;
  },

  /**
   * Get usage records of my invitation code
   * 获取我的邀请码的使用记录
   */
  getMyCodeUsages: async (): Promise<InvitationUsage[]> => {
    const response = await http.get<InvitationUsage[]>("/api/v1/invitations/my-code/usages");
    return response.data;
  },

  /**
   * Validate an invitation code (public endpoint)
   */
  validateCode: async (code: string): Promise<boolean> => {
    const response = await http.get<boolean>(`/api/v1/invitations/validate/${code}`);
    return response.data;
  },

  /**
   * Use an invitation code during registration
   */
  useCode: async (code: string): Promise<void> => {
    await http.post(`/api/v1/invitations/use/${code}`);
  },
};
